import { FC } from 'react';
import { Typography, TypographyProps } from '@mantine/core';

interface Props extends TypographyProps {
	raw: string;
}

export const RichText: FC<Props> = ({ raw, ...props }) => {
	return (
		<Typography
			{...props}
			className="rich-text"
			dangerouslySetInnerHTML={{
				__html: raw,
			}}
		></Typography>
	);
};
